import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";

const SECTIONS = ["products", "orders", "users", "banners", "dashboard"];

function PermissionEditor() {
  const { admin_id } = useParams();
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("http://kolibusiness.com/backend/get-admins.php")
      .then((res) => res.json())
      .then((admins) => {
        const admin = admins.find((a) => a.id === parseInt(admin_id));
        if (admin) setPermissions(admin.permissions || {});
        setLoading(false);
      });
  }, [admin_id]);

  const toggle = (section, field) => {
    setPermissions((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: !prev[section]?.[field],
      },
    }));
  };

  const handleSave = async () => {
    const res = await fetch("http://kolibusiness.com/backend/save-permissions.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ admin_id, permissions }),
    });

    const data = await res.json();
    alert(data.message);
  };

  if (loading) return <AdminLayout>Loading...</AdminLayout>;

  return (
    <AdminLayout>
      <h2>🔐 Edit Permissions</h2>
      {SECTIONS.map((sec) => (
        <div key={sec} style={{ marginBottom: 15 }}>
          <h4>{sec.toUpperCase()}</h4>
          <label>
            <input
              type="checkbox"
              checked={permissions[sec]?.is_enabled || false}
              onChange={() => toggle(sec, "is_enabled")}
            />
            Enabled
          </label>{" "}
          <label>
            <input
              type="checkbox"
              checked={permissions[sec]?.can_view || false}
              onChange={() => toggle(sec, "can_view")}
            />
            Can View
          </label>{" "}
          <label>
            <input
              type="checkbox"
              checked={permissions[sec]?.can_edit || false}
              onChange={() => toggle(sec, "can_edit")}
            />
            Can Edit
          </label>
        </div>
      ))}
      <button onClick={handleSave} style={{ padding: 10 }}>💾 Save Permissions</button>
    </AdminLayout>
  );
}

export default PermissionEditor;
